import request from '@/utils/request';
// 列表数据
export function queryBargainGoodsPageList(data) {
  return request({
    url: '/bargain/goods/queryBargainGoodsPageList',
    method: 'POST',
    data
  });
}
// 删除
export function removeBargainGoodsById(data) {
  return request({
    url: '/bargain/goods/removeBargainGoodsById',
    method: 'POST',
    data
  });
}
// 新增
export function saveBargainGoods(data) {
  return request({
    url: '/bargain/goods/saveBargainGoods',
    method: 'POST',
    data
  });
}
// 修改
export function updateBargainGoods(data) {
  return request({
    url: '/bargain/goods/updateBargainGoods',
    method: 'POST',
    data
  });
}
// 修改明细
export function fetchBargainGoodsDetailById(data) {
  return request({
    url: '/bargain/goods/fetchBargainGoodsDetailById',
    method: 'POST',
    data
  });
}
// 查询所有上架的商品列表
export function queryOnlineGoodsList(data) {
  return request({
    url: '/bargain/goods/queryOnlineGoodsList',
    method: 'POST',
    data
  });
}
// 获取砍价订单记录列表
export function queryBargainOrderLogPageList(data) {
  return request({
    url: '/bargain/order/log/queryBargainOrderLogPageList',
    method: 'POST',
    data
  });
}
// 获取砍价记录列表
export function queryUserBargainLogList(data) {
  return request({
    url: '/user/bargain/log/queryUserBargainLogList',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/bargainActivity.js